module.exports = __webpack_public_path__ + "static/humanitarian_card_img4@2x-359f175f3107469d2bdc16ae25acbe5e.jpg";